import { EntityApiKeysDto } from "@entity-api-keys/data/dto/entity-api-keys.dto";
import { EntityApiKeys } from "@entity-api-keys/domain/models/entity-api-key.model";
import { validateSync } from "class-validator";
import { inject, injectable } from "inversify";
import { EntityApiKeyMapper } from "./entity-api-key.mapper";

@injectable()
export class EntityApiKeysMapper {
    constructor(
        @inject(EntityApiKeyMapper)
        private readonly entityApiKeyMapper: EntityApiKeyMapper,
    ) {}

    map(dto: EntityApiKeysDto): EntityApiKeys {
        const errors = validateSync(dto);
        if (Boolean(errors.length)) {
            console.error(errors);
            return new EntityApiKeys([], 0);
        }

        const apiKeys = dto.results.mapNotNull((item) =>
            this.entityApiKeyMapper.map(item),
        );

        return new EntityApiKeys(apiKeys, dto.count);
    }
}
